
(() => {
  // Run on load + when Shopify re-renders sections in the editor
  const boot = (root = document) => {
    // Find common thumbnail containers – add your own class if needed
    const containers = root.querySelectorAll(
      '.product__thumbnails, .product-thumbs, .thumbnails, [data-thumbnails], .product-media__thumbnails'
    );
    containers.forEach(container => {
      // 1) Convert <a> -> <button> so they can’t navigate
      container.querySelectorAll('a').forEach(a => {
        // skip if already converted
        if (a.classList.contains('jci-thumb')) return;

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = (a.className ? a.className + ' ' : '') + 'jci-thumb';
        // keep the full image URL
        const href = a.getAttribute('href') || '';
        if (href) btn.setAttribute('data-full', href);
        // keep media id if present
        if (a.dataset.mediaId) btn.setAttribute('data-media-id', a.dataset.mediaId);
        if (a.getAttribute('data-media-id')) btn.setAttribute('data-media-id', a.getAttribute('data-media-id'));

        // move inner nodes across
        while (a.firstChild) btn.appendChild(a.firstChild);
        a.replaceWith(btn);
      });

      // 2) Single delegated click handler per container
      container.addEventListener('click', e => {
        const t = e.target.closest('.jci-thumb, [data-media-id]');
        if (!t) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const full = t.getAttribute('data-full') || '';
        const mediaId = t.getAttribute('data-media-id') || t.dataset.mediaId || '';

        // A) Dawn / media-gallery
        const gallery = root.querySelector('media-gallery');
        if (gallery && mediaId && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(mediaId, true);
          setActive(container, t);
          return;
        }

        // B) Try to scroll to a matching slide if your theme marks them with data-media-id
        if (mediaId) {
          const target = root.querySelector('[data-media-id="' + CSS.escape(mediaId) + '"]');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            setActive(container, t);
            return;
          }
        }

        // C) Fallback: swap the main <img> src
        const main =
          root.querySelector('[data-main-image] img') ||
          root.querySelector('.featured-media img') ||
          root.querySelector('.product__media-item.is-active img') ||
          root.querySelector('#ProductPhotoImg') ||
          root.querySelector('.product-gallery__image img') ||
          root.querySelector('.product__main-visual img');

        if (main && full) {
          main.src = full;
          main.removeAttribute('srcset'); // stop srcset overriding your swap
          const wrap = main.closest('a');
          if (wrap) wrap.href = full;
          setActive(container, t);
        }
      });
    });
  };

  const setActive = (container, el) => {
    container.querySelectorAll('.is-active-thumb').forEach(n => n.classList.remove('is-active-thumb'));
    el.classList.add('is-active-thumb');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(document));
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', e => boot(e.target));
  document.addEventListener('shopify:section:select', e => boot(e.target));
})();


if (!customElements.get('product-option')) {
  customElements.define('product-option', class ProductInfo extends HTMLElement {

      productData = {};

      constructor() {
        super();
        this.productOption = this;
        this.productId = this.productOption.dataset.productId;
        this.productUrl = this.productOption.dataset.productUrl;
        this.sectionId = this.productOption.dataset.sectionId;
        this.productData = this.getProductData(this.productId);
      }

      connectedCallback() {
        this.productOption.addEventListener('change', this.handleVariantChange.bind(this));

      }

      handleVariantChange(e){
        var optionSelectors = this.productOption.querySelectorAll('.option-selector');
        var { selectorType } = optionSelectors[0].dataset;
        var selectedOptions = this.getSelectedOptions(optionSelectors, selectorType);
        var variant = this.productData.variants.find((v) => v.options.every((val, index) => val === selectedOptions[index]));
        if(variant){
          document.querySelector(`#shopify-section-${this.sectionId} input[name='id']`).value = variant.id;
          this.renderProductInfo(variant);
        }
      }

      
      renderProductInfo(variant){
        let shouldFetchFullPage = false;

        let requestUrl = this.buildRequestUrlWithParams(this.productUrl, variant, shouldFetchFullPage);
        this.updateURL(this.productUrl, variant.id);

        fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          document.querySelector(`#shopify-section-${this.sectionId} .product-price`).innerHTML = html.querySelector(`#shopify-section-${this.sectionId} .product-price`).innerHTML;
          document.querySelector(`#shopify-section-${this.sectionId} .packaging-blocks`).innerHTML = html.querySelector(`#shopify-section-${this.sectionId} .packaging-blocks`).innerHTML;
        })
        .then(() => {
          // set focus to last clicked option value
          document.querySelector(`#shopify-section-${this.sectionId}`)?.focus();
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
        });
      }


      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      buildRequestUrlWithParams(url, variant, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (variant) {
          params.push(`variant=${variant.id}`);
        }

        return `${url}?${params.join('&')}`;
      }

      getSelectedOptions(optionSelectors, selectorType) {
        var selectedOptions = [];

        optionSelectors.forEach((selector) => {
          if (selectorType === 'dropdown') {
            selectedOptions.push(selector.querySelector('.cc-select__btn').textContent.trim());
          } else {
            selectedOptions.push(selector.querySelector('input:checked').value);
          }
        });

        return selectedOptions;
      };

      getProductData(productId) {
        var data = null;
        if (!this.productData[productId]) {
          this.productData[productId] = JSON.parse(document.getElementById('ProductJson-' + productId).innerHTML);
        }
        data = this.productData[productId];
        if (!data) {
          console.log('Product data missing (id: ' + productId + ')');
        }
        return data;
      };

  });
}